import React from "react";
import { Route, Routes } from "react-router-dom";
import TransactionPage from "./veiws/TransactionPage";
import "./styles/App.css";
import _ from "lodash";
import { netWork } from "./utils";
import Logo from './assets/logo.svg';
function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>404 - Page Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}

function App() {
  return (
    <div className="app">
      <header className="header">
        <div className="logo">
          <img className="logo-img" src={Logo} alt="logo" />
          <span className="logo-text">{_.capitalize(netWork)} Explorer</span>
        </div>
      </header>
      <div className="route-view">
        <Routes>
          <Route path="/tx/:hash" element={<TransactionPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
